import { List, Popper } from "@mui/material";
import { styled } from "@mui/material/styles";

const MENUPREFIX = "cascadingMenu";
const POPPERPREFIX = "cascadingMenuPopper";

export const menuClasses = {
  root: `${MENUPREFIX}-root`,
  item: `${MENUPREFIX}-item`,
};

export const CascadingMenuStyled = styled(List)(({ theme }) => ({
  [`&.${menuClasses.root}`]: {
    [`& .${menuClasses.item}`]: {
      paddingBottom: theme.spacing(0.5),
      paddingTop: theme.spacing(0),
      display: "flex",
      justifyContent: "space-between",
      "&:hover": {
        cursor: "pointer",
      },
      "& .MuiTypography-root": {
        textAlign: "center",
        "&:before": {
          content: "attr(data-content)",
          display: "block",
          color: theme.palette.primary.dark,
          fontWeight: 600,
          height: 0,
          visibility: "hidden",
        },
        "&:after": {
          content: "attr(data-content)",
          fontWeight: 400,
        },
      },
      "&:focus-within": {
        "& .MuiTypography-root:after": {
          color: theme.palette.primary.dark,
          fontWeight: 600,
        },
      },
    },
  },
}));

export const popperClasses = {
  root: `${POPPERPREFIX}-root`,
};

export const PopperStyled = styled(Popper)(({ theme }) => ({
  [`&.${popperClasses.root}`]: {
    zIndex: 1300,
    border: "1px solid #CACDDE",
    backgroundColor: theme.palette.gray.light,
  },
}));
